import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import { Icon } from '@iconify/react';
import ModalImage from 'react-modal-image';
import Masonry from 'react-masonry-css';

const categoryMenu = [
  {
    title: 'Consultas Médicas',
    category: 'consulta',
  },
  {
    title: 'Imagenología',
    category: 'imagen',
  },
  {
    title: 'Terapias',
    category: 'rehabilitacion',
  },
  {
    title: 'Atención Domiciliaria',
    category: 'domicilio',
  },
  {
    title: 'Odontología',
    category: 'odontologia',
  },
  {
    title: 'SGSST',
    category: 'sgsst',
  }
];

const portfolioData = [
  {
    href: '/especialidades/consulta',
    img: '/images/consulta.jpg',
    category: 'consulta',
    height: 299,
  },
  {
    href: '/especialidades/imagen',
    img: '/images/imagen.jpg',
    category: 'imagen',
    height: 299,
  },
  {
    href: '/especialidades/rehabilitacion',
    img: '/images/rehabilitacion.jpg',
    category: 'rehabilitacion',
    height: 299,
  },
  {
    href: '/especialidades/domicilio',
    img: '/images/domicilio.jpg',
    category: 'domicilio',
    height: 299,
  },
  {
    href: '/especialidades/odontologia',
    img: '/images/odontologia.jpg',
    category: 'odontologia',
    height: 299,
  },
  {
    href: '/especialidades/sgsst',
    img: '/images/sgsst.jpg',
    category: 'sgsst',
    height: 299,
  }
];

const MasonryGallery = () => {
  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(12);

  const breakPointColumns = {
    default: 3,
    1199: 2,
    767: 1,
  };

  return (
    <section id="gallery">
      <div className="st-height-b120 st-height-lg-b80" />
      <div className="container">
        <SectionHeading
          title="Nuestras especialidades y servicios"
          subTitle={`Ofrecemos atención médica general y especializada, terapias integrales, diagnóstico por imágenes y más.<br />Unimos calidad, experiencia y calidez humana para cuidar tu salud de forma integral.`}
        />
      </div>
      <div className="container">
        <div className="st-portfolio-wrapper">
          <div className="st-isotop-filter st-style1 text-center">
            <ul className="st-mp0">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>Todos</span>
              </li>
              {categoryMenu.map((item, index) => (
                <li className={active === item.category ? 'active' : ''} key={index}>
                  <span onClick={() => setActive(item.category)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <Masonry
            className="st-isotop st-style1 st-has-gutter st-lightgallery my-masonry-grid"
            breakpointCols={breakPointColumns}
          >
            {portfolioData.slice(0, itemShow).map((element, index) => (
              <div
                key={index}
                className={`st-isotop-item ${
                  active === 'all' ? '' : active !== element.category ? 'd-none' : ''
                }`}
              >
                <div className="st-project st-zoom st-lightbox-item st-link-hover-wrap">
                  <ModalImage
                    className="st-gallery-modal-initial-hidden"
                    small={element.img}
                    large={element.img}
                    alt={element.img}
                  />
                  <div className="st-project-img st-zoom-in">
                    <img
                      className="st-hover-hidden"
                      src={element.img}
                      alt={element.img}
                    />
                  </div>
                  <span className="st-link-hover">
                    <i>
                      <Icon icon="fa-solid:arrows-alt" />
                    </i>
                  </span>
                </div>
              </div>
            ))}
          </Masonry>
          <div className="text-center">
            {active === 'all' && portfolioData.length > itemShow && (
              <>
                <div className="st-height-b65 st-height-lg-b40" />
                <span
                  className="st-btn st-style1 st-color1 st-size-medium st-flex-center st-gap-x-5"
                  onClick={() => setItemShow(itemShow + 4)}
                >
                  <span>Ver más</span>
                  <Icon icon="bi:arrow-right" />
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
    </section>
  );
};

export default MasonryGallery;
